import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'lib/ComponentProps';

import IsSitecoreEditing from 'src/utils/isSitecoreEditing';

import { EditorHelp } from '../_EditorHelp/_EditorHelp';

import styles from './TwoHalves.module.css';

export default function TwoHalves(props: ComponentProps): JSX.Element {
	const isEditing = IsSitecoreEditing();
	
	return (
		<>
			<EditorHelp text="Two Halves START" indent color={'blue'} />
			<section className={`${styles.grid} ${!isEditing && styles.gridNotEditing} pad maxWidth`}>
				<div className={`${!isEditing && styles.flex} pad maxWidth`}>
					<Placeholder name="rcnlearn-halfleft" rendering={props.rendering} />
				</div>
				<div className={`${!isEditing && styles.flex} pad maxWidth`}>
					<Placeholder name="rcnlearn-halfright" rendering={props.rendering} />
				</div>
			</section>
			<EditorHelp text="Two Halves END" indent color={'blue'} />
		</>
	);
}
